module.exports = __webpack_public_path__ + "static/img/9.3407096.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/9.png
// module id = F1aA
// module chunks = 0